import { ClassRepository } from '../../api/repository/class';
import type { QltClass } from '../../api/types';
import { createResourceStore } from './resource-store';

export const useQltClassStore = createResourceStore<QltClass>(ClassRepository);
